import { AttributeWrite } from 'src/app/shared/models/attributes/attributeWrite';

export class EvaluationResponseAttributeWriteModel {
  constructor(
    public evaluationAssignmentId: string,
    public attributeWriteModel: AttributeWrite
  ) {}
}
